import React from 'react';
import '../Analysis_A/TextAnomalityAnalysis.scss';
import Text_Anomality_Analysis from '../Analysis_A/Text_Anomality_Analysis';
import Text_Markers_Analysis from '../Analysis_A/Text_Markers_Analysis';
import DynamicChart from '../Graphics/ActivityAnalysis/DynamicChart';
import CommunityActivityChart from '../Graphics/ActivityAnalysis/CommunityActivityChart';
import DiscussionDetails from '../DiscussionDetails/DiscussionDetails';
import PageTabs from '../components/PageTabs';
import './Pages.scss';
import { useLocation, useNavigate } from 'react-router-dom';
import { PAGE_KEYS } from '../utils/pageAccess';

function DisscussionsAnalysis({ allowedPages = [] }) {

  const location = useLocation();
  const navigate = useNavigate();

  const tabs = [
    { id: 'activity', label: 'Активность дискуссий', route: '/diss', key: PAGE_KEYS.DISCUSSIONS_ACTIVITY },
    { id: 'community-activity', label: 'Активность по сообществам', route: '/diss/community-activity', key: PAGE_KEYS.DISCUSSIONS_COMMUNITY },
    { id: 'anomaly', label: 'Аномальные дискуссии', route: '/diss/anomaly', key: PAGE_KEYS.DISCUSSIONS_ANOMALY },
    { id: 'markers', label: 'Психолингвистические показатели', route: '/diss/markers', key: PAGE_KEYS.DISCUSSIONS_MARKERS },
    { id: 'disscussions', label: 'Детали дискуссий', route: '/diss/disscussions', key: PAGE_KEYS.DISCUSSIONS_DETAILS }
  ];

  const filteredTabs = tabs.filter(tab => allowedPages.includes(tab.key));

  function getTabByPath(pathname) {
    if (pathname === '/diss') return 'activity';
    for (const tab of tabs) {
      if (tab.route === pathname) return tab.id;
    }
    return 'activity';
  }

  const activeTab = getTabByPath(location.pathname);

  function handleTabChange(tabId) {
    const tab = tabs.find(t => t.id === tabId);
    if (tab) {
      navigate(tab.route);
    }
  }
    return (filteredTabs.length > 0 ? (
    <div className="top-level-page-container">
      <PageTabs activeTab={activeTab} setActiveTab={handleTabChange} tabs={filteredTabs.map(({id, label}) => ({ id, label }))} />
      <div className="page-content">
        {activeTab === 'disscussions' && (
          <div className="discussion-details">
            <DiscussionDetails />
          </div>
        )}
        {activeTab === 'activity' && (
          <DynamicChart />
        )}
        {activeTab === 'community-activity' && (
          <CommunityActivityChart isCommunityActivityTab={true} />
        )}
        {activeTab === 'anomaly' && (
          <Text_Anomality_Analysis />
        )}
        {activeTab === 'markers' && (
          <Text_Markers_Analysis />
        )}
      </div>
    </div>
  ) : (
    <div className="top-level-page-container">
      <h1>У вас нет доступа к этой странице</h1>
    </div>
  ));
}

export default DisscussionsAnalysis;
